import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function DashboardHeader({
    showSummary = true,
}) {
    return (
        <Box
            sx={{
                animation: "dashHeaderFadeIn 0.5s cubic-bezier(0, 0, 0.2, 1) both",
                "@keyframes dashHeaderFadeIn": {
                    from: { opacity: 0, transform: "translateY(8px)" },
                    to: { opacity: 1, transform: "translateY(0)" },
                },
            }}
        >
            {showSummary && (
                <Typography
                    variant="body1"
                    sx={{
                        color: "#4b5563",
                        fontWeight: 300,
                        letterSpacing: "0.01em",
                        lineHeight: 1.6,
                        mt: 0.5,
                    }}
                >
                    Vue synthétique des absences, actualités et notifications.
                </Typography>
            )}
        </Box>
    );
}
